export default __webpack_public_path__ + "static/media/Tabl_2.cd85d357.svg";